var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isIncomplete)?_c('span',{staticClass:"incomplete-record-indicator",attrs:{"role":"img","aria-label":"Fiche incomplète","title":"Fiche incomplète"}},[_c('feather-icon',{attrs:{"icon":"FlagIcon","size":"16"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }